<i18n>
{
    "en_US": {
        "export-as-html": "Export as HTML",
        "export-as-pdf": "Export as PDF",
        "save": "Save note",
        "send-by-email": "Send by email"
    },
    "fr_FR": {
        "export-as-html": "Exporter en HTML",
        "export-as-pdf": "Exporter en PDF",
        "save": "Enregistrer la note",
        "send-by-email": "Envoyer par email"
    }
}
</i18n>

<template>
    <div class="btn-group">
        <button type="button" class="btn btn-primary" v-on:click="save" v-bind:title="$t('save')">
            <i class="fa fa-save" aria-hidden="true"></i>
        </button>
        <button type="button" class="btn btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="sr-only"></span>
        </button>
        <div class="dropdown-menu dropdown-export blue dropdown-menu-right">
            <a class="dropdown-item" v-on:click="exportPDF">
                <i class="fa fa-file-pdf"></i>
                {{$t("export-as-pdf")}}
            </a>
            <a class="dropdown-item" v-on:click="exportHTML">
                <i class="fab fa-html5"></i>
                {{$t("export-as-html")}}
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" v-on:click="showModalEmail">
                <i class="fas fa-at"></i>
                {{$t("send-by-email")}}
            </a>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations, mapActions } from "vuex";

    export default {
        name: "ExportSelector",
        computed: {
            ...mapState("note", ["selectedNote"])
        },
        mounted: function() {
            // Fixing a bug between bootstrap and material design...
            $(this.$el).find("button.dropdown-toggle").dropdown();
        },
        methods: {
            save: function() {
                // Edit a note
                if (this.selectedNote && this.selectedNote.id) {
                    this.editNote(this.selectedNote)
                        .then(function() {
                            this.$Progress.finish();
                        }.bind(this))
                        .catch(function() {});
                }
                // Create a note
                else {
                    this.createNote(this.selectedNote)
                        .then(function(response) {
                            this.$Progress.finish();
                            this.$router.push({
                                name: "home.filled-note-editor",
                                params: {
                                    note_id: response.data.id
                                }
                            });
                        }.bind(this))
                        .catch(function() {});
                }
            },
            exportPDF: function() {
                this.$http.post("/notes/pdf", {
                    title: this.selectedNote.title,
                    content: this.selectedNote.content
                }).then(function() {
                    this.$Progress.finish();
                    // We call to get it
                    window.location = process.env.VUE_APP_BASE_URL + "/notes/pdf";
                }.bind(this)).catch(function() {});
            },
            exportHTML: function() {
                this.$http.post("/notes/html", {
                    title: this.selectedNote.title,
                    content: this.selectedNote.content
                }).then(function() {
                    this.$Progress.finish();
                    // We call to get it
                    window.location = process.env.VUE_APP_BASE_URL + "/notes/html";
                }.bind(this)).catch(function() {});
            },
            ...mapActions("note", ["createNote", "editNote"]),
            ...mapMutations("application", ["showModalEmail"])
        }
    }
</script>

<style scoped>
    .btn-group {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        margin: 0 !important;
    }
    .btn-group .dropdown {
        display: inline-block;
    }
    .btn-primary {
        margin-top: 1px;
        margin-bottom: 0;
        -webkit-box-shadow: none;
        -moz-box-shadow: none;
        box-shadow: none;
        background-image: none;
        vertical-align: top;
        -webkit-font-smoothing: subpixel-antialiased;
        font-size: 12px;
        transition: border 0.2s linear 0s, color 0.2s linear 0s, width 0.2s linear 0s, background-color 0.2s linear 0s;
        border-radius: 0.1rem;
        text-shadow: 0 -1px 0 rgba(0,0,0,.2);
        display: inline-block;
        padding: 6px 12px;
        font-weight: 100;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        touch-action: manipulation;
        cursor: pointer;
        user-select: none;
    }
    .dropdown-toggle-split {
        padding-left: 8px;
        padding-right: 8px;
    }
    .dropdown-menu.blue {
        background-color: rgb(36, 124, 240) !important;
    }
    .dropdown-item {
        cursor: pointer;
        font-weight: 100;
        font-size: 14px;
        padding-left: 20px;
        transition: border 0.2s linear 0s, color 0.2s linear 0s, width 0.2s linear 0s, background-color 0.2s linear 0s;
    }
    .dropdown-menu.blue .dropdown-item {
        color: #fff;
    }
    .dropdown-menu.blue .dropdown-item:hover {
        background-color: #0069d9 !important;
    }
    .dropdown-item i {
        padding-right: 5px;
    }

    .dropdown-export {
        width: 180px;
        left: -120px;
    }
</style>
